import { css } from "@emotion/react";
import React, { useMemo } from "react";
import { useTheme } from "../theme";
import { useWindowResize } from "../hooks/useWindowResize";
import { useTab } from "./useTab";

export interface BaseTabGroupProps {
  position?: "start" | "center" | "end";
  underline?: "always" | "shadow";
}

export interface TabGroupProps
  extends BaseTabGroupProps, React.HTMLProps<HTMLDivElement> {
  children?: React.ReactNode;
}

/**
 * @deprecated TabUI instead
 */
export const TabGroup = ({
  position = "start",
  underline,
  children,
}: TabGroupProps) => {
  const theme = useTheme();
  const { width } = useWindowResize();
  const { currentTab } = useTab();

  const indicatorStyle = useMemo(() => {
    return currentTab
      ? {
          opacity: 1,
          width: currentTab.offsetWidth,
          left: currentTab.offsetLeft,
        }
      : {
          opacity: 0,
          width: 0,
          left: 0,
        };
    // 画面サイズが変更された場合に更新する必要があるため、widthを含めなければいけない
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab, width]);

  return (
    <div
      css={[
        css`
          position: relative;
          box-sizing: border-box;
          display: flex;
          flex-wrap: nowrap;
          border-bottom: 3px solid transparent;
        `,
        {
          justifyContent:
            position === "start"
              ? "flex-start"
              : position === "end"
                ? "flex-end"
                : "center",
        },
        underline === "shadow"
          ? {
              boxShadow: theme.shadows[1],
              color: theme.palette.text.primary,
              backgroundColor: theme.palette.background.paper,
            }
          : underline === "always"
            ? {
                borderBottomColor: "#e0e0e0",
              }
            : undefined,
      ]}
    >
      {React.Children.map(children as React.ReactElement[], (child, index) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
        return React.cloneElement(child, { index } as any);
      })}
      {currentTab ? (
        <div
          css={css({
            position: "absolute",
            bottom: -3,
            width: 200,
            height: 3,
            backgroundColor: theme.palette.intentions.primary.main,
            transition: `opacity ${theme.transitions.duration.standard} ${theme.transitions.easing.sharp},
                            left ${theme.transitions.duration.shortest} ${theme.transitions.easing.easeInOut},
                            width ${theme.transitions.duration.shortest} ${theme.transitions.easing.easeInOut}`,
          })}
          style={indicatorStyle}
        />
      ) : null}
    </div>
  );
};
